const selector = '[data-lazy-background]';

export default function initDeferredBackgrounds() {
    const loadBackground = element => {
        const url = element.dataset.lazyBackground;

        if (!url) {
            return;
        }

        element.style.backgroundImage = `url("${url.replace(/"/g, '\\"')}")`;
        element.removeAttribute('data-lazy-background');
    };

    const intersectionObserver = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    loadBackground(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, {rootMargin: '300px 0px'})
        : null;

    const observe = root => {
        const elements = [];

        if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) {
            return;
        }

        if (root.matches && root.matches(selector)) {
            elements.push(root);
        }

        elements.push(...root.querySelectorAll(selector));
        elements.forEach(element => intersectionObserver
            ? intersectionObserver.observe(element)
            : loadBackground(element)
        );
    };

    observe(document);

    new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(observe);
        });
    }).observe(document.body, {childList: true, subtree: true});
}
